const resizeObserver = new ResizeObserver(() => {
    $(".tab-content").css('height', 'auto');
    $(".tab-pane").css('width', '100%');
});

let selectedSuppliers = [];
let activeSteps = [];

window.CreateSupplyTaskRequest = {
    init() {
        this.initWizard();
        this.handleHiddenSteps();
        this.handleModalShow();
        this.handleButtonClicks();
        this.handleSupplierSelection();
        this.validateDealSampleRequestForm();
        this.validateDealInformationRequestForm();
        this.validateDealPricingRequestForm();
    },

    validateDealSampleRequestForm() {
        $('#sample-request-form').validate({
            onsubmit: true,
            onkeyup: false,
            onclick: false,
            rules: {
                "deal_sample_request[sample_details]": {
                    required: true
                },
                "deal_sample_request[recipient_name]": {
                    required: true
                },
                "deal_sample_request[deadline]": {
                    required: true
                },
                "deal_sample_request[delivery_address]": {
                    required: true
                }
            },
            messages: {
                'deal_sample_request[sample_details]': 'Please provide any relevant details suppliers should know before sending the samples',
                'deal_sample_request[recipient_name]': 'Please provide the recipient\'s name',
                'deal_sample_request[deadline]': 'Minimum 2 weeks from today',
                'deal_sample_request[delivery_address]': 'Please provide the address for delivery'
            },
            errorPlacement: (error, element) => {
                error.insertAfter(element);
            },
            onfocusout: function (element) {
                return $(element).valid();
            }
        });
    },

    validateDealInformationRequestForm() {
        $('#information-request-form').validate({
            onsubmit: true,
            onkeyup: false,
            onclick: false,
            rules: {
                "deal_information_request[details]": {
                    required: true
                },
                "deal_information_request[deadline]": {
                    required: true
                }
            },
            messages: {
                'deal_information_request[details]': 'Please provide the additional information you need from suppliers',
                'deal_information_request[deadline]': 'Minimum 2 days from today'
            },
            errorPlacement: (error, element) => {
                if (element.attr('name') === 'deal_information_request[details]') {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            onfocusout: function (element) {
                return $(element).valid();
            }
        });
    },

    validateDealPricingRequestForm() {
        $('#pricing-request-form').validate({
            onsubmit: true,
            onkeyup: false,
            onclick: false,
            rules: {
                "deal_pricing_request[incoterm_ids]": {
                    required: true
                },
                "deal_pricing_request[details]": {
                    required: true
                },
                "deal_pricing_request[deadline]": {
                    required: true
                }
            },
            messages: {
                'deal_pricing_request[incoterm_ids]': 'Incoterms must be selected',
                'deal_pricing_request[details]': 'Please provide the additional information you need from suppliers',
                'deal_pricing_request[deadline]': 'Minimum 1 week from today'
            },
            errorPlacement: (error, element) => {
                error.insertAfter(element);
            },
            onfocusout: function (element) {
                return $(element).valid();
            }
        });
    },

    initWizard() {
        $('#supply-task-request-smartwizard').smartWizard({
            theme: "square",
            justified: true,
            autoAdjustHeight: true,
            enableURLhash: false,
            transition: {
                animation: 'fade',
                speed: '400',
                easing: ''
            },
            keyboard: {
                keyNavigation: false
            },
            toolbar: {
                position: 'none',
                showNextButton: true,
                showPreviousButton: true,
            },
            anchor: {
                enableNavigation: false,
                enableNavigationAlways: false,
                enableDoneState: true,
                markPreviousStepsAsDone: true,
                unDoneOnBackNavigation: true
            }
        });

        $("#supply-task-request-smartwizard").on("leaveStep", function (e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
            if (stepDirection != "forward") {
                return true;
            }

            let valid = [];

            if (currentStepIndex == 0) {
                valid.push($("[name='deal_sample_request[title]']").valid());
                valid.push($("textarea[name='deal_sample_request[sample_details]']").valid());
                valid.push($("input[name='deal_sample_request[recipient_name]']").valid());
                valid.push($("input[name='deal_sample_request[delivery_address]']").valid());
                valid.push($("input[name='deal_sample_request[deadline]']").valid());

                if (!valid.every(Boolean)) {
                    return false
                }
            } else if (currentStepIndex == 1) {
                valid.push($("[name='deal_information_request[title]']").valid());
                valid.push($("textarea[name='deal_information_request[details]']").valid());
                valid.push($("input[name='deal_information_request[deadline]']").valid());

                if (!valid.every(Boolean)) {
                    return false
                }
            } else if (currentStepIndex == 2) {
                valid.push($("[name='deal_pricing_request[title]']").valid());
                valid.push($("textarea[name='deal_pricing_request[details]']").valid());
                valid.push($("input[name='deal_pricing_request[deadline]']").valid());
                valid.push($(".incoterms").valid());

                if (destinationIsRequired()) {
                    var hasDestination = CreateSupplyTaskRequest.hasAnyDestination();
                    document.getElementById('destinations-error').classList.toggle('d-none', hasDestination);
                    valid.push(hasDestination);
                }

                if (!valid.every(Boolean)) {
                    return false
                }
            } else if (currentStepIndex == 3) {
                if (nextStepIndex == 4) {
                    CreateSupplyTaskRequest.handleReviewScreen();
                }
            }

            return !valid.includes(false);
        });

        if (document.querySelector('#step-0') != null) {
            resizeObserver.observe(document.querySelector('#step-0'));
            resizeObserver.observe(document.querySelector('#step-1'));
            resizeObserver.observe(document.querySelector('#step-2'));
            resizeObserver.observe(document.querySelector('#step-3'));
            resizeObserver.observe(document.querySelector('#step-4'));
        }
    },

    handleModalShow() {
        $('#supply-task-request-modal').on('show.bs.modal', function () {
            let allSteps = [0, 1, 2, 3, 4];
            let activeStepsString = document.getElementById("selected_supply_tasks").value;
            activeSteps = activeStepsString.split(',').map(Number);
            if (!activeSteps.includes(3)) {
                activeSteps.push(3);
            }
            if (!activeSteps.includes(4)) {
                activeSteps.push(4);
            }
            activeSteps.sort();
            let hiddenSteps = allSteps.filter(x => !activeSteps.includes(x))
            $('#supply-task-request-smartwizard').smartWizard("unsetState", allSteps, "hidden");
            $('#supply-task-request-smartwizard').smartWizard("unsetState", allSteps, "default");
            $('#supply-task-request-smartwizard').smartWizard("setState", hiddenSteps, "hidden");
            $('#supply-task-request-smartwizard').smartWizard("setState", activeSteps, "default");

            CreateSupplyTaskRequest.resetSampleRequestForm();
            CreateSupplyTaskRequest.resetInformationRequestForm();
            CreateSupplyTaskRequest.resetPricingRequestForm();
            CreateSupplyTaskRequest.resetSupplierSelectionForm();
            CreateSupplyTaskRequest.resetReviewScreen();

            $('#supply-task-request-smartwizard').smartWizard("reset");

            $('#sample-request-form').valid();
            $('#information-request-form').valid();
            $('#pricing-request-form').valid();

            const errorElems = document.querySelectorAll('.error');
            errorElems.forEach(el => el.classList.remove('error'));

            $('#supply-task-request-smartwizard').smartWizard("goToStep", activeSteps[0]);
        });
    },

    handleButtonClicks() {
        $("#samples-continue-modal-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("next");
        });

        $("#rfi-continue-modal-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("next");
        });

        $("#pricing-continue-modal-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("next");
        });

        $("#suppliers-continue-modal-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("next");
        });

        $("#edit-sample-request-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("goToStep", 0);
        });

        $("#edit-information-request-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("goToStep", 1);
        });

        $("#edit-pricing-request-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("goToStep", 2);
        });

        $("#edit-suppliers-selected-btn").click(function () {
            $('#supply-task-request-smartwizard').smartWizard("goToStep", 3);
        });

        $("#create-supply-tasks-modal-btn").click(async function () {
            $(this).prop('disabled', true);

            try {
                if (activeSteps.includes(0)) {
                    await CreateSupplyTaskRequest.submitSampleRequest();
                }

                if (activeSteps.includes(1)) {
                    await CreateSupplyTaskRequest.submitInformationRequest();
                }

                if (activeSteps.includes(2)) {
                    await CreateSupplyTaskRequest.submitPricingRequest();
                }

                $('#supply-task-request-modal').modal('hide');
                window.location.reload();
            } catch (error) {
                console.error("An error occurred while processing the requests:", error);
                sentry.captureException(error);
                $('#supply-task-request-modal').modal('hide');
                window.location.reload();
            } finally {
                $(this).prop('disabled', false);
            }
        });
    },

    submitSampleRequest() {
        return new Promise((resolve, reject) => {
            let dealUUID = $('#sample-request-form [name="deal_sample_request[deal_uuid]"]').val();
            let title = $('#sample-request-form [name="deal_sample_request[title]"]').val();
            let sampleDetails = $('#sample-request-form textarea[name="deal_sample_request[sample_details]"]').val();
            let recipientName = $('#sample-request-form input[name="deal_sample_request[recipient_name]"]').val();
            let deliveryAddress = $('#sample-request-form input[name="deal_sample_request[delivery_address]"]').val();
            let deadline = $('#sample-request-form input[name="deal_sample_request[deadline]"]').val();
            let suppliersIds = selectedSuppliers.map(team => team.id);
            const attachmentIds = Array.from(
                document.querySelectorAll('#sample-request-form input[name="deal_sample_request[deal_sample_request_attachment_ids][]"]')
            ).map(elm => elm.value);

            $.ajax({
                url: '/deal_sample_requests',
                method: 'POST',
                data: {
                    deal_uuid: dealUUID,
                    title: title,
                    sample_details: sampleDetails,
                    recipient_name: recipientName,
                    delivery_address: deliveryAddress,
                    deadline: deadline,
                    supplier_team_ids: suppliersIds,
                    deal_sample_request_attachment_ids: attachmentIds
                },
                success: resolve,
                error: reject
            });
        });
    },

    submitInformationRequest() {
        return new Promise((resolve, reject) => {
            let dealUUID = $('#information-request-form [name="deal_information_request[deal_uuid]"]').val();
            let title = $('#information-request-form [name="deal_information_request[title]"]').val();
            let details = $('#information-request-form textarea[name="deal_information_request[details]"]').val();
            let deadline = $('#information-request-form input[name="deal_information_request[deadline]"]').val();
            let suppliersIds = selectedSuppliers.map(team => team.id);
            const attachmentIds = Array.from(
                document.querySelectorAll('#information-request-form input[name="deal_information_request[deal_information_request_attachment_ids][]"]')
            ).map(elm => elm.value);

            $.ajax({
                url: '/deal_information_requests',
                method: 'POST',
                data: {
                    deal_uuid: dealUUID,
                    title: title,
                    details: details,
                    deadline: deadline,
                    supplier_team_ids: suppliersIds,
                    deal_information_request_attachment_ids: attachmentIds
                },
                success: resolve,
                error: reject
            });
        });
    },

    // Reads every non-blank destination row currently in the list — mirrors how benchmarkLinks is
    // read elsewhere in this file (Array.from + map + filter), since both are `[]`-named repeatable
    // text inputs with the same full-replace-on-submit semantics.
    getDestinations() {
        return Array.from(
            document.querySelectorAll('#pricing-request-form input[name="deal_pricing_request[destinations][]"]')
        ).map((el) => el.value).filter(Boolean);
    },

    hasAnyDestination() {
        return CreateSupplyTaskRequest.getDestinations().length > 0;
    },

    // Resolves a "common option, or your own text" pair of fields (Payment Terms, Contract
    // Length) down to a single value: the custom text when "other" was chosen, else the
    // select's own value.
    resolveSelectWithOther(selectName, otherName) {
        const selectValue = $(`#pricing-request-form select[name="deal_pricing_request[${selectName}]"]`).val();
        if (selectValue === 'other') {
            return $(`#pricing-request-form input[name="deal_pricing_request[${otherName}]"]`).val();
        }
        return selectValue;
    },

    // Shows/hides a review row depending on whether there's anything to show — these fields (unlike
    // the always-present product info/incoterm/deadline) are all optional, so an empty row would just
    // read as a blank heading with nothing under it.
    toggleReviewRow(rowId, contentId, value) {
        const row = document.getElementById(rowId);
        if (!row) return;

        if (value) {
            document.getElementById(contentId).textContent = value;
            row.classList.remove('d-none');
        } else {
            row.classList.add('d-none');
        }
    },

    // Reads a logistics field's own on-page label (rather than duplicating translated copy in JS)
    // so the review line reads e.g. "Pallet Type: euro" using whatever locale the form itself renders in.
    labeledFieldValue(selector) {
        const field = document.querySelector(`#pricing-request-form ${selector}`);
        if (!field || !field.value) return null;

        const wrapper = field.closest('.col-12');
        const label = wrapper ? wrapper.querySelector('label') : null;
        const labelText = label ? label.textContent.trim() : '';

        return labelText ? `${labelText}: ${field.value}` : field.value;
    },

    submitPricingRequest() {
        return new Promise((resolve, reject) => {
            let dealUUID = $('#pricing-request-form [name="deal_pricing_request[deal_uuid]"]').val();
            let title = $('#pricing-request-form [name="deal_pricing_request[title]"]').val();
            let details = $('#pricing-request-form textarea[name="deal_pricing_request[details]"]').val();
            let packagingRequirements = $('#pricing-request-form textarea[name="deal_pricing_request[packaging_requirements]"]').val();
            let deadline = $('#pricing-request-form input[name="deal_pricing_request[deadline]"]').val();
            let incoterm_ids = $('.incoterms').select2('data').map(option => option.id)
            const destinations = this.getDestinations();
            let suppliersIds = selectedSuppliers.map(team => team.id);
            const attachmentIds = Array.from(
                document.querySelectorAll('#pricing-request-form input[name="deal_pricing_request[deal_pricing_request_attachment_ids][]"]')
            ).map(elm => elm.value);
            const benchmarkLinks = Array.from(
                document.querySelectorAll('#pricing-request-form input[name="deal_pricing_request[benchmark_links][]"]')
            ).map(elm => elm.value).filter(Boolean);

            // The Simple/Advanced choice control (specs/007-simple-advanced-pricing-request) is either
            // a live radio group (unlocked deal, flag enabled) or a single hidden field (locked deal, or
            // flag disabled) — both share this name, so prefer whichever one is actually present.
            const requestType = $('#pricing-request-form [name="deal_pricing_request[request_type]"]:checked').val()
                || $('#pricing-request-form [name="deal_pricing_request[request_type]"]').val();
            const isAdvanced = requestType === 'advanced';

            const data = {
                deal_uuid: dealUUID,
                title: title,
                details: details,
                packaging_requirements: packagingRequirements,
                deadline: deadline,
                incoterm_ids: incoterm_ids,
                destinations: destinations,
                supplier_team_ids: suppliersIds,
                deal_pricing_request_attachment_ids: attachmentIds,
                benchmark_links: benchmarkLinks,
                request_type: requestType
            };

            // Advanced-only fields are only read (and submitted) when Advanced is actually selected —
            // the server-side type resolution already ignores these for a Simple request regardless,
            // but this keeps the submitted payload itself honest about what a Simple request contains.
            if (isAdvanced) {
                data.pallet_type = $('#pricing-request-form select[name="deal_pricing_request[pallet_type]"]').val();
                data.pallet_height_cm = $('#pricing-request-form input[name="deal_pricing_request[pallet_height_cm]"]').val();
                data.max_pallet_weight_kg = $('#pricing-request-form input[name="deal_pricing_request[max_pallet_weight_kg]"]').val();
                data.master_carton_weight_kg = $('#pricing-request-form input[name="deal_pricing_request[master_carton_weight_kg]"]').val();
                data.payment_terms = this.resolveSelectWithOther('payment_terms_option', 'payment_terms_other');
                data.contract_length = this.resolveSelectWithOther('contract_length_option', 'contract_length_other');
                data.launch_min_deadline = $('#pricing-request-form input[name="deal_pricing_request[launch_min_deadline]"]').val();
                data.launch_max_deadline = $('#pricing-request-form input[name="deal_pricing_request[launch_max_deadline]"]').val();
                data.deal_pricing_request_skus_attributes = Array.from(
                    document.querySelectorAll('#pricing-request-form #sku-fields-wrapper .nested-fields')
                ).map((row) => ({
                    lot_name: row.querySelector('[name$="[lot_name]"]')?.value,
                    recurring_quantity: row.querySelector('[name$="[recurring_quantity]"]')?.value,
                    frequency: row.querySelector('[name$="[frequency]"]')?.value,
                    unit_of_measure: row.querySelector('[name$="[unit_of_measure]"]')?.value,
                    current_price: row.querySelector('[name$="[current_price]"]')?.value,
                    target_cost_price: row.querySelector('[name$="[target_cost_price]"]')?.value,
                    target_retail_price: row.querySelector('[name$="[target_retail_price]"]')?.value,
                    note: row.querySelector('[name$="[note]"]')?.value
                })).filter((sku) => sku.lot_name || sku.recurring_quantity || sku.unit_of_measure || sku.current_price || sku.target_cost_price || sku.target_retail_price || sku.note);
            }

            $.ajax({
                url: '/deal_pricing_requests',
                method: 'POST',
                data: data,
                success: resolve,
                error: reject
            });
        });
    },

    handleHiddenSteps() {
        const navLinks = document.querySelectorAll('ul.nav.m-auto li a.nav-link');
        navLinks.forEach((navLink) => {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        const parentLi = navLink.parentElement;
                        if (parentLi) {
                            if (navLink.classList.contains('hidden')) {
                                parentLi.classList.add('hidden');
                            } else {
                                parentLi.classList.remove('hidden');
                            }
                        }
                    }
                });
            });

            observer.observe(navLink, {
                attributes: true
            });
        });
    },

    handleSupplierSelection() {
        const selectAllSuppliersButton = document.getElementById('select-all-suppliers');
        const supplierCheckboxes = document.querySelectorAll('#supplier-select-form-view input[type="checkbox"]');
        const confirmSelectionButton = document.getElementById('suppliers-continue-modal-btn');


        selectAllSuppliersButton.addEventListener('click', function () {
            supplierCheckboxes.forEach(function (checkbox) {
                checkbox.checked = true;
                const teamId = checkbox.dataset.teamId;
                const teamCard = document.getElementById(`supplier-select-${teamId}-card`);
                teamCard.style.backgroundColor = '#F4FBFE';
            });
            updateButtonState();
        });

        supplierCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', updateButtonState);
        });

        updateButtonState();

        function updateButtonState() {
            var anyCheckboxSelected = false;
            selectedSuppliers = [];
            supplierCheckboxes.forEach(function (checkbox) {
                const team = {"name": checkbox.dataset.teamName, "id": checkbox.dataset.teamId};
                const teamId = checkbox.dataset.teamId
                if (checkbox.checked) {
                    anyCheckboxSelected = true;
                }
                if (checkbox.checked) {
                    selectedSuppliers.push(team);
                    const teamCard = document.getElementById(`supplier-select-${teamId}-card`);
                    teamCard.style.backgroundColor = '#F4FBFE';
                } else {
                    const teamCard = document.getElementById(`supplier-select-${teamId}-card`);
                    teamCard.style.backgroundColor = '#FFFFFF';
                }
            });

            confirmSelectionButton.disabled = !anyCheckboxSelected;
        }
    },

    handleReviewScreen() {
        document.querySelector('#sample-request-review').style.display = 'none';
        document.querySelector('#information-request-review').style.display = 'none';
        document.querySelector('#pricing-request-review').style.display = 'none';

        if (activeSteps.includes(0)) {
            CreateSupplyTaskRequest.sampleRequestReview();
        }

        if (activeSteps.includes(1)) {
            CreateSupplyTaskRequest.informationRequestReview();
        }

        if (activeSteps.includes(2)) {
            CreateSupplyTaskRequest.pricingRequestReview();
        }

        let selectedSuppliersText = '<ul class="mb-0">' +
            selectedSuppliers.map(team => '<li>' + team.name + '</li>').join('') +
            '</ul>';
        $('#supplier-names-review').html(selectedSuppliersText);
    },

    resetSampleRequestForm() {
        const date = new Date();
        date.setDate(date.getDate() + 14);
        const dateFormat = date.toISOString().split('T')[0];

        let userName = document.getElementById("current_user_name").value;
        let teamAddress = document.getElementById("team_address").value;

        $('#sample-request-form textarea[name="deal_sample_request[sample_details]"]').val("");
        $('#sample-request-form input[name="deal_sample_request[recipient_name]"]').val(userName);
        $('#sample-request-form input[name="deal_sample_request[delivery_address]"]').val(teamAddress);
        $('#sample-request-form input[name="deal_sample_request[deadline]"]').val(dateFormat);


        let attachmentElements = document.querySelectorAll('#sample-request-form input[name="deal_sample_request[deal_sample_request_attachment_ids][]"]')
        attachmentElements.forEach(function (attachmentElement) {
            attachmentElement.remove();
        });
        $('#deal-sample-request-div.col-12.col-md-6.mb-2').children('.dz-preview').remove();
    },

    resetInformationRequestForm() {
        const date = new Date();
        date.setDate(date.getDate() + 2);
        const dateFormat = date.toISOString().split('T')[0];

        $('#information-request-form textarea[name="deal_information_request[details]"]').val("");
        $('#information-request-form input[name="deal_information_request[deadline]"]').val(dateFormat);

        let attachmentElements = document.querySelectorAll('#information-request-form input[name="deal_information_request[deal_information_request_attachment_ids][]"]')
        attachmentElements.forEach(function (attachmentElement) {
            attachmentElement.remove();
        });
        $('#deal-information-request-attachments').children('.dz-preview').remove();
    },

    resetPricingRequestForm() {
        const date = new Date();
        date.setDate(date.getDate() + 7);
        const dateFormat = date.toISOString().split('T')[0];

        let teamAddress = document.getElementById("team_address").value;

        const detailsField = document.querySelector('#pricing-request-form textarea[name="deal_pricing_request[details]"]');
        const packagingRequirementsField = document.querySelector('#pricing-request-form textarea[name="deal_pricing_request[packaging_requirements]"]');
        const deadlineField = document.querySelector('#pricing-request-form input[name="deal_pricing_request[deadline]"]');

        // These fields carry a data-default-value attribute reflecting whatever the server
        // pre-filled on initial render (either a reused prior request's details, or the plain
        // default) — restore to that instead of a hardcoded blank/today+7/team-address, since
        // this reset runs on every modal open, including the very first one.
        $(detailsField).val(detailsField ? (detailsField.getAttribute('data-default-value') || '') : '');
        $(packagingRequirementsField).val(packagingRequirementsField ? (packagingRequirementsField.getAttribute('data-default-value') || '') : '');
        $(deadlineField).val(deadlineField ? (deadlineField.getAttribute('data-default-value') || dateFormat) : dateFormat);

        // Destinations are now a repeatable list rather than one field — restore each
        // server-rendered row (.default-destination-row) to its own data-default-value, and drop
        // any row the buyer added during this (now-cancelled) session, mirroring how reused
        // attachments vs. session-added ones are told apart below.
        const destinationList = document.getElementById('destination-list');
        if (destinationList) {
            Array.from(destinationList.querySelectorAll('.destination-row')).forEach(function (row) {
                if (row.classList.contains('default-destination-row')) {
                    const input = row.querySelector('input');
                    if (input) input.value = input.getAttribute('data-default-value') || teamAddress;
                } else {
                    row.remove();
                }
            });
        }
        document.getElementById('destinations-error').classList.add('d-none');


        var incotermsSelect = document.querySelector('.incoterms');
        var incotermsElement = $(".incoterms").select2();
        var defaultIncotermIds = incotermsSelect ?
            (incotermsSelect.getAttribute('data-default-incoterm-ids') || '').split(',').filter(Boolean) : [];

        if (defaultIncotermIds.length > 0) {
            incotermsElement.val(defaultIncotermIds).trigger('change');
        } else {
            var options = incotermsSelect ? incotermsSelect.options : [];
            for (let option of options) {
                if (option.text === 'DDP') {
                    incotermsElement.val(option.value).trigger('change');
                    break;
                }
            }
        }

        // Only clear attachments added during this same (uncommitted) modal session — never the
        // reused-attachment previews/hidden fields rendered server-side from the prior request,
        // which are marked with .reused-attachment-input / .reused-attachment-preview. Without this
        // guard, this reset (which runs on every modal open, including the very first) would wipe
        // out the carried-over attachments before the buyer ever saw them.
        let attachmentElements = document.querySelectorAll('#pricing-request-form input[name="deal_pricing_request[deal_pricing_request_attachment_ids][]"]:not(.reused-attachment-input)')
        attachmentElements.forEach(function (attachmentElement) {
            attachmentElement.remove();
        });
        $('#deal-pricing-request-attachments').children('.dz-preview:not(.reused-attachment-preview)').remove();
    },

    resetSupplierSelectionForm() {
        $('input[type="checkbox"]:enabled').prop('checked', false);
        CreateSupplyTaskRequest.handleSupplierSelection();
    },

    resetReviewScreen() {
        $('#sample-details-review').text('');
        $('#recipient-name-review').text('');
        $('#destination-review').text('');
        $('#sample-deadline-review').text('');

        $('#information-details-review').text('');
        $('#information-deadline-review').text('');
    },

    sampleRequestReview() {
        document.querySelector('#sample-request-review').style.display = 'block';

        let sampleDetailsText = $('#sample-request-form textarea[name="deal_sample_request[sample_details]"]').val();
        $('#sample-details-review').text(sampleDetailsText);

        let recipientNameText = $('#sample-request-form input[name="deal_sample_request[recipient_name]"]').val();
        $('#recipient-name-review').text(recipientNameText);

        let deliveryAddressText = $('#sample-request-form input[name="deal_sample_request[delivery_address]"]').val();
        $('#delivery-address-review').text(deliveryAddressText);

        let deadlineText = $('#sample-request-form input[name="deal_sample_request[deadline]"]').val();
        let deadlineDate = new Date(deadlineText);

        let day = deadlineDate.getDate();
        let month = deadlineDate.toLocaleString('default', {month: 'long'});
        let year = deadlineDate.getFullYear();

        let formattedDeadline = `${day} ${month} ${year}`;
        $('#sample-deadline-review').text(formattedDeadline);

        $('#sample-attachment-review').empty();
        let attachmentElements = document.querySelector('.drop-zone-preview.sample-request').cloneNode(true);
        attachmentElements.querySelectorAll('.remove-attachment').forEach(el => el.remove());
        $('#sample-attachment-review').append(attachmentElements);
    },

    informationRequestReview() {
        document.querySelector('#information-request-review').style.display = 'block';

        let informationDetailsText = $('#information-request-form textarea[name="deal_information_request[details]"]').val();
        $('#information-details-review').text(informationDetailsText);

        let deadlineText = $('#information-request-form input[name="deal_information_request[deadline]"]').val();
        let deadlineDate = new Date(deadlineText);

        let day = deadlineDate.getDate();
        let month = deadlineDate.toLocaleString('default', {month: 'long'});
        let year = deadlineDate.getFullYear();

        let formattedDeadline = `${day} ${month} ${year}`;
        $('#information-deadline-review').text(formattedDeadline);

        $('#information-attachment-review').empty();
        let attachmentElements = document.querySelector('.drop-zone-preview.info-request').cloneNode(true);
        attachmentElements.querySelectorAll('.remove-attachment').forEach(el => el.remove());
        $('#information-attachment-review').append(attachmentElements);
    },

    // Mirrors the buyer-facing detail set shown on the pricing request's own show page
    // (deal_pricing_requests/show.slim) — same fields, read from the not-yet-submitted form instead
    // of a persisted DealPricingRequest, so the buyer can double-check everything before it's sent.
    pricingRequestReview() {
        document.querySelector('#pricing-request-review').style.display = 'block';

        // specs/007-simple-advanced-pricing-request — Advanced-only fields must never show on a Simple
        // request's review, even though their underlying form inputs can still hold a value (e.g. the
        // buyer's saved specs/009 defaults pre-filling a hidden Advanced section). Mirrors the same
        // isAdvanced check submitPricingRequest() already uses to keep these out of the submitted payload.
        const requestType = $('#pricing-request-form [name="deal_pricing_request[request_type]"]:checked').val()
            || $('#pricing-request-form [name="deal_pricing_request[request_type]"]').val();
        const isAdvanced = requestType === 'advanced';

        let pricingDetailsText = $('#pricing-request-form textarea[name="deal_pricing_request[details]"]').val();
        $('#pricing-details-review').text(pricingDetailsText);

        this.toggleReviewRow(
            'pricing-packaging-requirements-review-row',
            'pricing-packaging-requirements-review',
            $('#pricing-request-form textarea[name="deal_pricing_request[packaging_requirements]"]').val()
        );

        const benchmarkLinks = Array.from(
            document.querySelectorAll('#pricing-request-form input[name="deal_pricing_request[benchmark_links][]"]')
        ).map((el) => el.value).filter(Boolean);
        const benchmarkLinksRow = document.getElementById('pricing-benchmark-links-review-row');
        const benchmarkLinksList = document.getElementById('pricing-benchmark-links-review');
        benchmarkLinksList.innerHTML = '';
        benchmarkLinks.forEach((url) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.textContent = url;
            li.appendChild(link);
            benchmarkLinksList.appendChild(li);
        });
        benchmarkLinksRow.classList.toggle('d-none', benchmarkLinks.length === 0);

        var pricingTypeText = $('.incoterms').select2('data').map(option => option.text).join(', ');
        $('#pricing-incoterm-review').text(pricingTypeText);

        const destinations = this.getDestinations();
        const destinationsRow = document.getElementById('pricing-destinations-review-row');
        const destinationsList = document.getElementById('pricing-destinations-review');
        destinationsList.innerHTML = '';
        destinations.forEach((location) => {
            const li = document.createElement('li');
            li.textContent = location;
            destinationsList.appendChild(li);
        });
        destinationsRow.classList.toggle('d-none', destinations.length === 0);

        let deadlineText = $('#pricing-request-form input[name="deal_pricing_request[deadline]"]').val();
        let deadlineDate = new Date(deadlineText);

        let day = deadlineDate.getDate();
        let month = deadlineDate.toLocaleString('default', {month: 'long'});
        let year = deadlineDate.getFullYear();

        let formattedDeadline = `${day} ${month} ${year}`;
        $('#pricing-deadline-review').text(formattedDeadline);

        const skusRow = document.getElementById('pricing-skus-review-row');
        const skusContainer = document.getElementById('pricing-skus-review');
        skusContainer.innerHTML = '';
        const skuSummaries = !isAdvanced ? [] : Array.from(
            document.querySelectorAll('#pricing-request-form #sku-fields-wrapper .nested-fields')
        ).map((row) => {
            const lotName = row.querySelector('[name$="[lot_name]"]')?.value;
            if (!lotName) return null;

            const quantity = row.querySelector('[name$="[recurring_quantity]"]')?.value;
            const frequencySelect = row.querySelector('[name$="[frequency]"]');
            const frequency = frequencySelect ? frequencySelect.options[frequencySelect.selectedIndex]?.text : '';
            const unitOfMeasure = row.querySelector('[name$="[unit_of_measure]"]')?.value;
            const currentPrice = row.querySelector('[name$="[current_price]"]')?.value;
            const targetCostPrice = row.querySelector('[name$="[target_cost_price]"]')?.value;
            const targetRetailPrice = row.querySelector('[name$="[target_retail_price]"]')?.value;

            const details = [
                quantity && frequency ? `${quantity} / ${frequency.toLowerCase()}` : null,
                unitOfMeasure,
                currentPrice ? `Current cost price ${currentPrice}` : null,
                targetCostPrice ? `Target cost price ${targetCostPrice}` : null,
                targetRetailPrice ? `Target retail price ${targetRetailPrice}` : null
            ].filter(Boolean).join(' · ');

            return { lotName, details };
        }).filter(Boolean);

        skuSummaries.forEach(({ lotName, details }) => {
            const nameEl = document.createElement('p');
            nameEl.className = 'font-weight-bold mb-0';
            nameEl.textContent = lotName;
            skusContainer.appendChild(nameEl);

            if (details) {
                const detailsEl = document.createElement('p');
                detailsEl.className = 'font-size-xs text-muted';
                detailsEl.textContent = details;
                skusContainer.appendChild(detailsEl);
            }
        });
        skusRow.classList.toggle('d-none', skuSummaries.length === 0);

        const logisticsSummary = !isAdvanced ? '' : [
            this.labeledFieldValue('select[name="deal_pricing_request[pallet_type]"]'),
            this.labeledFieldValue('input[name="deal_pricing_request[pallet_height_cm]"]'),
            this.labeledFieldValue('input[name="deal_pricing_request[max_pallet_weight_kg]"]'),
            this.labeledFieldValue('input[name="deal_pricing_request[master_carton_weight_kg]"]')
        ].filter(Boolean).join(' · ');
        this.toggleReviewRow('pricing-logistics-review-row', 'pricing-logistics-review', logisticsSummary);

        this.toggleReviewRow(
            'pricing-payment-terms-review-row',
            'pricing-payment-terms-review',
            isAdvanced ? this.resolveSelectWithOther('payment_terms_option', 'payment_terms_other') : ''
        );

        this.toggleReviewRow(
            'pricing-contract-length-review-row',
            'pricing-contract-length-review',
            isAdvanced ? this.resolveSelectWithOther('contract_length_option', 'contract_length_other') : ''
        );

        const launchMinDeadline = $('#pricing-request-form input[name="deal_pricing_request[launch_min_deadline]"]').val();
        const launchMaxDeadline = $('#pricing-request-form input[name="deal_pricing_request[launch_max_deadline]"]').val();
        const launchTimeframe = !isAdvanced ? '' : [launchMinDeadline, launchMaxDeadline].filter(Boolean).join(' - ');
        this.toggleReviewRow('pricing-launch-timeframe-review-row', 'pricing-launch-timeframe-review', launchTimeframe);

        $('#pricing-attachment-review').empty();
        let attachmentElements = document.querySelector('.drop-zone-preview.pricing-request').cloneNode(true);
        attachmentElements.querySelectorAll('.remove-attachment').forEach(el => el.remove());
        $('#pricing-attachment-review').append(attachmentElements);
    }
};

function destinationIsRequired() {
    const addressRequiredIncotermCodes = ["DAP", "DPU", "DDP", "FCA", "CIP", "CPT"]
    const selectedOptions = $('.incoterms').find(':selected').toArray()
    return selectedOptions.some(opt =>
        addressRequiredIncotermCodes.includes((opt.textContent || '').trim())
    )
}
